import React, { useState } from 'react';
import {
	Button,
	useEditController,
	useNotify,
	useRecordContext,
	useTranslate,
} from 'react-admin';
// eslint-disable-next-line import/no-extraneous-dependencies
import { EditContextProvider } from 'ra-core';
import Dialog from '@mui/material/Dialog';

const EditInDialogButton = (props) => {
	const { children, maxWidth, fullWidth } = props;
	const [open, setOpen] = useState(false);
	const translate = useTranslate();
	const record = useRecordContext();
	const handleClick = () => {
		setOpen(true);
	};
	const handleStateChange = () => {
		setOpen(false);
	};
	const notify = useNotify();
	const edc = useEditController({
		id: record.id,
		redirect: false,
		mutationOptions: {
			onSuccess: () => {
				notify('ra.notification.updated', {
					type: 'info',
					messageArgs: { smart_count: 1 },
					undoable: true,
				});
				handleStateChange();
			},
		},
	});

	return (
		<>
			<Button
				onClick={handleClick}
				type="button"
				label={translate('ra.action.edit')}
			/>
			{
				open
					? (
						<Dialog
							open={open}
							onClose={handleStateChange}
							maxWidth={maxWidth}
							fullWidth={fullWidth}
						>
							<EditContextProvider value={{ ...edc }}>
								{children}
							</EditContextProvider>
						</Dialog>
					)
					: null
			}
		</>
	);
};

export default EditInDialogButton;
